'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Return plural noun form
 * @param {number} n
 * @param {string} one
 * @param {string} few
 * @param {string} many
 * @returns string
 * @example
 * ```ts
 * pluralize(6, 'яблоко', 'яблока', 'яблок') -> яблок
 * ```
 */
const pluralize = (n, one, few, many) => {
    const nP100 = n % 100;
    const nP10 = n % 10;
    if (nP10 === 1 && nP100 !== 11) {
        return one;
    }
    if (nP10 >= 2 && nP10 <= 4 && (nP100 < 10 || nP100 >= 20)) {
        return few;
    }
    return many;
};
const setupPluralize = (wordSet) => (n, options = {}) => {
    const [one, few, many = few] = options.possessive ? wordSet.slice(1) : wordSet;
    return pluralize(n, one, few, many);
};
const pluralizeSeconds = setupPluralize(['секунда', 'секунды', 'секунд']);
const pluralizeMinutes = setupPluralize(['минута', 'минуты', 'минут']);
const pluralizeHours = setupPluralize(['час', 'часа', 'часов']);
const pluralizeDays = setupPluralize(['день', 'дня', 'дней']);
const pluralizeMonth = setupPluralize(['месяц', 'месяца', 'месяцев']);
const pluralizeYears = setupPluralize(['год', 'года', 'лет']);
const pluralizeByUnit = (n, unit, options) => {
    switch (unit) {
        case 'month':
            return pluralizeMonth(n, options);
        case 'year':
            return pluralizeYears(n, options);
        case 'day':
            return pluralizeDays(n, options);
        case 'hour':
            return pluralizeHours(n, options);
        case 'minute':
            return pluralizeMinutes(n, options);
        case 'second':
            return pluralizeSeconds(n, options);
        default:
            return '';
    }
};

exports.default = pluralize;
exports.pluralizeByUnit = pluralizeByUnit;
exports.setupPluralize = setupPluralize;
//# sourceMappingURL=pluralize.js.map
